// extracted by mini-css-extract-plugin
module.exports = {"edit__textarea":"_hT","edit__btns_wrapper":"_hU","edit__submit_btn":"_hV","edit__cancel_btn":"_hW"};